import updateCandidate from "./updateCandidate";
import getRegion from "./getRegion";
export default {
    updateCandidate,
    getRegion
}